import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';

import { PresentationComponent } from './presentation.component';
import { PackagesComponent } from 'app/components/packages/packages.component';
import { BlockInfoComponent } from 'app/components/block-info/block-info.component';
import { BlockPmsComponent } from 'app/components/block-pms/block-pms.component';
import { BlockStepsComponent } from 'app/components/block-steps/block-steps.component';
import { BlockDnmComponent } from 'app/components/block-dnm/block-dnm.component';
import { BlockLabPartnersComponent } from 'app/components/block-lab-partners/block-lab-partners.component';
@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        RouterModule,
        NgbModule
    ],
    declarations: [ PresentationComponent, PackagesComponent, BlockInfoComponent, BlockPmsComponent, BlockStepsComponent, BlockDnmComponent, BlockLabPartnersComponent ],
    exports:[ PresentationComponent, PackagesComponent, BlockInfoComponent, BlockPmsComponent, BlockStepsComponent , BlockDnmComponent, BlockLabPartnersComponent],
    providers: []
})
export class PresentationModule { }
